module.exports = __webpack_public_path__ + "img/yuyue.49dbdbdd.png";